module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-MediumItalic.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-MediumItalic.eot
 ** module id = 347
 ** module chunks = 0
 **/